import { BaseEntity } from 'yt-ng-framework';

export class Drzava extends BaseEntity {
    constructor(){
        super();
    }
    Naziv: string = null;
    ISOAlpha2Code: string = null;
    ISOAlpha3Code: string = null;
    ISONumericCode: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.ISOAlpha2Code = input.ISOAlpha2Code;
        this.ISOAlpha3Code = input.ISOAlpha3Code;
        this.ISONumericCode = input.ISONumericCode;
        
        return this;
    }

    Serialize(input: Drzava){
        return input;
    }
}
